import { selectAnchor } from "../core/utilities";
import CategoryModel, { CategoryType } from "../models/CategoryModel";
import DiscussionModel from "../models/DiscussionModel";

export default class IdeaNumberTextController {
  private categoryType: CategoryType;

  /**
   * Checks if page is an Idea Lab
   *
   * @returns Promise<boolean>
   */
  async isIdeaLab(): Promise<boolean> {
    this.categoryType = await CategoryModel.getCategoryTypeCached();
    console.debug("Idea Number Text - Category type: ", this.categoryType);

    return this.categoryType === CategoryType.ideas;
  }
  /**
   * Tries to add the idea number to the idea metadata section
   *
   * @returns boolean
   */
  async addNumberMetadata(): Promise<boolean> {
    const pageMetadata =
      await DiscussionModel.getDiscussionFromJsonPageCached();
    if (pageMetadata) {
      const $container = selectAnchor(".o__discussion-meta");
      if ($container) {
        const $metaItem = selectAnchor(".o__meta-item", $container);
        if ($metaItem) {
          const $niuItem = $metaItem.cloneNode() as HTMLElement;
          $niuItem.innerHTML = `<div class="o__meta-label">Idea Number: ${pageMetadata.Discussion.DiscussionID}</div>`;
          $container.append($niuItem);
          return true;
        }
      }
    }
    return false;
  }
}
